import { Toast } from 'vant';
import { reqSeckill, queryOrderResult } from '../../model/apis/order';
import { pay } from '../../model/apis/pay';
import { SkuData, SkuDetailData } from '../../model/store/modules/ticket';

export const useActivityBuy = () => {
  const sleep = (ms: number) => new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });

  const pollOrderStatus = async (
    activityToken: string,
    retries = 5,
    interval = 1000,
    currentAttempt = 0,
  ): Promise<any> => {
    if (currentAttempt === 0) {
      Toast.loading({
        message: '抢购下单中',
        duration: 0,
      });
    }

    const data = await queryOrderResult({ activityToken });
    if (data && Object.keys(data).length > 0) {
      Toast.clear();
      return data;
    }

    if (currentAttempt >= retries - 1) {
      Toast.clear();
      // 超过最大轮询次数终止
      throw new Error('下单超时');
    }

    await sleep(interval);
    return pollOrderStatus(activityToken, retries, interval, currentAttempt + 1);
  };

  const payOrder = async (data: any, skuData: SkuData, categoryId: string) => {
    const payInfo = {
      payOrderInfo: data,
      skuData,
      categoryId,
    };
    pay(payInfo, { isPushPage: true });
  };

  const handleActivityBuy = async (
    skuData: SkuDetailData | null,
    categoryId: string,
  ) => {
    console.log('handleActivityBuy', skuData);

    if (!skuData?.effectiveActivityInfo) {
      return;
    }

    const { effectiveActivityInfo } = skuData;
    const {
      activityCode, salePrice, skuId, itemId,
    } = effectiveActivityInfo;
    const params = {
      activityCode,
      businessId: '5',
      payAmount: salePrice,
      skuId,
      salePrice,
      purchaseNum: 1,
      orderPort: 2,
      item_id: itemId,
      needQueryUnPayOrder: true,
    };
    try {
      const { activityToken } = await reqSeckill(params);
      const data = await pollOrderStatus(activityToken);
      console.log('res', data);
      if (data) {
        if (salePrice === 0) {
          Toast.clear();
          Toast('已免费领取成功');
        }
        await payOrder({
          payMoney: salePrice,
          payOrderId: data.payOrderId,
          billNo: data.billNo,
          businessScene: data.businessScene,
          businessType: data.businessType,
        }, skuData as SkuData, categoryId);
      }
    } catch (error) {
      Toast.clear();
      Toast('下单失败，请稍后重试');
    }
  };

  return {
    handleActivityBuy,
  };
};
